import { SiGooglecalendar } from "react-icons/si"; 
import { BiRefresh } from "react-icons/bi"; 
import { BsSearch, BsFileEarmarkPdf } from "react-icons/bs";
import React, { useEffect, useRef, useState } from 'react';
import FullCalendar from '@fullcalendar/react'; // must go before plugins
import allLocales from '@fullcalendar/core/locales-all';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import { makeStyles } from '@material-ui/core/styles';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import '../../../styles/FullCalendar/FullCalendar.css';
import CxDialog from '../../cx/CxDialog';
import CxDlgAlert from '../../cx/CxDlgAlert';
import CxSnackbar from '../../cx/CxSnackbar';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxDlgCalendar from '../../cx/CxDlgCalendar';
import CxDlgTable from '../../cx/CxDlgTable';
import CxDate from '../../cx/CxDate';
import * as FxFetch from '../../fx/FxFetch';
import * as FxLog from '../../fx/FxLog';
import * as FxDat from '../../fx/FxDat';
import * as FxTable from '../../fx/FxTable';
import { clearStore, getStoreValue, StoreCalendarEvent, StoreCalendarView, isApp } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxToolbar from '../../cx/CxToolbar';
import CxToolbarPopper from './../../cx/CxToolbarPopper';
import CxDlgCheckList from './../../cx/CxDlgCheckList';
import { useAccess } from '../../hx/useAccess';
import { BsCalendar } from "react-icons/bs";
import moment from 'moment';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const useStyles = makeStyles({
  calendar: {
    margin: 'var(--ibs_container_margin)',
    padding: '2px',
  },
});

const MxCalendarView = (props) => {
  const [{ trans }] = useTranslation();
  const [{ isFullAccess }] = useAccess(trans('field.calendar'));
  const [{ navTo }] = useNav();
  const MIN_WIDTH = 800;

  // ─── FESTIVOS ─────────────────────────────────────────────────────────────────
  // Cada festivo: { date: 'YYYY-MM-DD', name: 'Nombre del festivo' }
  // Se carga desde el endpoint 'cal/holidays' en doLoadHolidays()
  const [holidays, setHolidays] = useState([]);

  const classes = useStyles();
  const strLocale = getStoreValue('StoreSession', 'txLocale').replace('_', '-'); // ej: 'en-GB'

  const [calView, setCalView] = React.useState({ title: '', bg: '' });

  const [calEnabled, setCalEnabled] = useState(true);
  const [calCols, setCalCols] = useState([]);
  const [calColsSelected, setCalColsSelected] = useState(''); // for resource view
  const [calEvents, setCalEvents] = useState([]);

  const [dlgNewDate, setDlgNewDate] = useState(false);
  const [dlgSearch, setDlgSearch] = useState(false);

  const rf_toolbar = useRef(null);
  const rf_calendar = useRef(null);
  const rf_popper1 = useRef(null);
  const rf_popper2 = useRef(null);

  const r_dlg_alert = React.useRef(null);

  const r_dlg_calendar = useRef(null);

  const r_dlg_search = useRef(null);

  const r_snack_error = useRef(null);

  const r_calView = useRef('timeGridWeek');
  const r_calDate = useRef(null);

  const r_dlg_res_cols = useRef(null);

  const r_headerSize = useRef(190);

  const rf_google_import_dtFrom = React.useRef(null);
  const rf_google_import_dtTo = React.useRef(null);
  const [dlgGoogleImport, setDlgGoogleImport] = React.useState(false);
  
  // eslint-disable-next-line no-unused-vars
  const [storeCalendarView, setStoreCalendarView] = useSessionStorage('StoreCalendarView', StoreCalendarView);
  const [storeCalendarEvent, setStoreCalendarEvent] = useSessionStorage('StoreCalendarEvent', StoreCalendarEvent);

  // Creado por Asistente de Programación (Gemini) - 09/05/2026
  const doExportPdf = () => {
    const objElement = document.querySelector('.fc');
    if (objElement) {
      html2canvas(objElement, {
        scale: 2,
        useCORS: true,
        logging: false
      }).then((objCanvas) => {
        const strImgData = objCanvas.toDataURL('image/png');
        const objPdf = new jsPDF('l', 'mm', 'a4');
        const nuImgWidth = 280;
        const nuImgHeight = (objCanvas.height * nuImgWidth) / objCanvas.width;
        
        objPdf.text(`${rf_popper1.current.getVal()}`, 10, 10);
        objPdf.addImage(strImgData, 'PNG', 10, 20, nuImgWidth, nuImgHeight);
        objPdf.save(`calendar.pdf`);
      });
    }
  };

  const doRefresh = () => {
    fetchEvents();
  };

  const doSynchGoogleCalendar = async () => {
    setDlgGoogleImport(false);

    if (rf_google_import_dtFrom.current.isEmpty()) {
      r_snack_error.current.setValAndOpen(trans('field.required') + ": " + trans('field.from'));
      return;
    }
    if (rf_google_import_dtTo.current.isEmpty()) {
      r_snack_error.current.setValAndOpen(trans('field.required') + ": " + trans('field.to'));
      return;
    }
    
    r_dlg_alert.current.setText(trans('msg.importing'));
    r_dlg_alert.current.setProgressMsg(trans('msg.please_wait'));
    r_dlg_alert.current.setTextColor('var(--ibs_color_blue)');
    r_dlg_alert.current.setHasButtonClose(false);
    r_dlg_alert.current.setOpen(true);
    
    // 1. Llamamos al endpoint que hace la sincronización invisible
    let record = {};
    record['dtFrom'] = rf_google_import_dtFrom.current.getVal();
    record['dtTo'] = rf_google_import_dtTo.current.getVal();

    const objRes = await FxFetch.doJsonX('cal/sync', record);
    // 2. Comprobamos si el backend nos responde que todo ha ido bien
    if (objRes && objRes.theStatus === 'OK') {
      r_dlg_alert.current.setOpen(false);
      doRefresh(); 

    } else {
      r_dlg_alert.current.setOpen(false);
      if (objRes.theValue === 'rv_not_installed') {
        r_snack_error.current.setValAndOpen(trans('msg.operation_not_configured'));
      }
    }
  };

  const getHeaderToolbar = () => {
    return {
      center: window.innerWidth > MIN_WIDTH ? 'title' : '',
      right: window.innerWidth > MIN_WIDTH ? 'customButtonToday customButtonPrev,customButtonNext' : 'customButtonToday customButtonPrev,customButtonNext',
      left: window.innerWidth > MIN_WIDTH ? 'customButtonWeek,customButtonResWeek,customButtonDay,customButtonRes,customButtonListWeek' : 'title'
    }
  }

  useEffect(() => {
    clearStore('StoreCalendarEvent', storeCalendarEvent);
    function handleResize(e) {
      r_calView.current = (window.innerWidth > MIN_WIDTH ? (storeCalendarView.selectedView||'timeGridWeek') : 'timeGridDay');
      setView(r_calView.current);
      rf_calendar.current.getApi().setOption('headerToolbar', getHeaderToolbar());
      rf_calendar.current.getApi().setOption('contentHeight', window.innerHeight - r_headerSize.current);
      fetchEvents();
      r_dlg_res_cols.current.setOpen(false);
    }
    window.addEventListener('resize', handleResize);

    if (storeCalendarView.itCalendarCol) {
      // usuario viene desde un evento
      r_calView.current = (window.innerWidth > MIN_WIDTH ? storeCalendarView.selectedView : 'timeGridDay');
    } else {
      // usuario abrió cal desde el menú
      r_calView.current = (window.innerWidth > MIN_WIDTH ? (storeCalendarView.selectedView||'timeGridWeek') : 'timeGridDay');
    }
    Promise.all([loadBranchSettings(), doLoadHolidays()]).then((result) => {
      setView(r_calView.current);
      loadCols();
    });

    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line
  }, []);

  // Carga festivos desde el backend.
  const doLoadHolidays = () => {
    let obRecord = {};
    Promise.all([FxFetch.doJsonX('cal/holidays', obRecord)]).then((arrResult) => {
      if (arrResult[0]) {
        const arrHols = JSON.parse(arrResult[0].theValue || '[]');
        const arrFormatted = arrHols
          .filter(item => item.dtFrom && item.dtFrom.length >= 10) // Protege contra nulos y cadenas cortas
          .map(item => {
            const date = new Date(item.dtFrom);
            if (isNaN(date.getTime())) {
              FxLog.infox('MxCalendarView.doLoadHolidays', '...fecha inválida ignorada:', item.dtFrom);
              return null;
            }
            
            const strTitle = item.txTypeCalendarHol || 'Holiday';
            // Adaptación mínima: boNational == '1' significa nacional
            const boIsNational = String(item.boNational) === '1';
            
            return {
              id: item.itCalendarHol,
              title: strTitle,
              name: strTitle,  // alias usado por renderDayHeader
              start: item.dtFrom.substring(0, 10),
              allDay: true,
              display: 'background',
              // Si es nacional, usamos la clase nacional, si no, la regional
              className: boIsNational ? 'ibs-holiday-national' : 'ibs-holiday-regional'
            };
          })
          .filter(Boolean); // elimina los nulos de fechas inválidas
        FxLog.infox('MxCalendarView.doLoadHolidays', '...arrFormatted:', arrFormatted);
        setHolidays(arrFormatted);
      }
    });
  };

  const loadBranchSettings = async () => {
    try {
      let record = {};
      return Promise.all([FxFetch.doJsonX('cal/sett', record)]).then((result) => {
        if (result[0]) {
          storeCalendarView.boSingleCalendar = result[0].boSingleCalendar;
          storeCalendarView.txWeekDays = result[0].txWeekDays;
          storeCalendarView.txStartHour = result[0].txStartHour;
          storeCalendarView.txWorkTime1From = result[0].txWorkTime1From;
          storeCalendarView.txWorkTime1To = result[0].txWorkTime1To;
          storeCalendarView.txWorkTime2From = result[0].txWorkTime2From;
          storeCalendarView.txWorkTime2To = result[0].txWorkTime2To;
          storeCalendarView.nuIntervalMins = result[0].nuIntervalMins;
          setStoreCalendarView(storeCalendarView);
        }
      });

    } catch (error) {
      FxLog.errorx('MxCalendarView.loadBranchSettings', error);
    }
  }

  const loadCols = () => {
    try {
      let url = "cal/cols";
      let record = {};
      return Promise.all([FxFetch.doJsonX(url, record)]).then((result) => {
        if (result[0]) {
          setCalCols(result[0]);
          
          // Creado por Asistente de Programación - 09/05/2026
          // Recuperamos preferencia guardada
          const strSavedColId = localStorage.getItem('MxCalendarView.itCalendarCol');
          const objActiveCol = result[0].find(item => item.id === strSavedColId);

          if (!storeCalendarView.itCalendarCol) {
            if (objActiveCol) {
              // Existe en storage y es válido en la DB actual
              storeCalendarView.itCalendarCol = objActiveCol.id;
              storeCalendarView.txTypeCalendarCol = objActiveCol.title;
            } else if (result[0][0]) {
              // No existe o es inválido (columna borrada): fallback al primero
              storeCalendarView.itCalendarCol = result[0][0].id;
              storeCalendarView.txTypeCalendarCol = result[0][0].title;
              localStorage.setItem('MxCalendarView.itCalendarCol', storeCalendarView.itCalendarCol);
            } else {
              setCalEnabled(false);
            }
          }
          
          Promise.all([setStoreCalendarView(storeCalendarView)]).then(() => {
            rf_popper1.current.setVal(storeCalendarView.itCalendarCol);
            doDatesSet();
          });
        }
      });
    } catch (error) {
      FxLog.errorx('MxCalendarView.loadCols', error);
    }
  }

  const doResColsChoose = () => {
    let colsSelected = localStorage.getItem('MxCalendarView.colsSelected') || '';
    let calColsFinal = calCols.map((item) => (
      item = { ...item, checked: colsSelected.includes(item.id) ? '1' : '0' }
    ));
    r_dlg_res_cols.current.setList(calColsFinal);
    r_dlg_res_cols.current.setOpen(true);
  }
  const doResColsChanged = (colsSelected) => {
    localStorage.setItem('MxCalendarView.colsSelected', colsSelected);
    setCalColsSelected(colsSelected);
  }

  const doDisplayCol = (selectedCol) => {
    try {
      storeCalendarView.itCalendarCol = selectedCol.split('|')[0];
      storeCalendarView.txTypeCalendarCol = selectedCol.split('|')[1];
      
      // Creado por Asistente de Programación - 09/05/2026
      localStorage.setItem('MxCalendarView.itCalendarCol', storeCalendarView.itCalendarCol);

      Promise.all([setStoreCalendarView(storeCalendarView)]).then((result) => {
        doDatesSet();
      });
    } catch (error) {
      FxLog.errorx('MxCalendarView.doDisplayCol', error);
    }
  }
  const doDateClick = (e) => {
    if (!calEnabled) {
      return;
    }
    if (e.resource) {
    }
    storeCalendarEvent.inCalendar = null;
    storeCalendarEvent.dtFrom = moment(e.date).format('YYYY-MM-DD HH:mm:ss');
    storeCalendarEvent.boComm = '';

    if (r_calView.current === 'timeGridWeek' || r_calView.current === 'listWeek' || r_calView.current === 'timeGridDay') {
      // vista simple
      storeCalendarEvent.itCalendarCol = storeCalendarView.itCalendarCol;
      storeCalendarEvent.txTypeCalendarCol = storeCalendarView.txTypeCalendarCol;
    } else {
      // vista de recursos/columnas
      storeCalendarEvent.itCalendarCol = e.resource.id;
      storeCalendarEvent.txTypeCalendarCol = e.resource.title;
    }

    Promise.all([setStoreCalendarEvent(storeCalendarEvent)]).then((result) => {
      navTo("calendar-form");
    });
  }

  const doEventClick = (e) => {
    if (e.event.extendedProps.isHoliday) return;

    storeCalendarEvent.inCalendar = e.event.id;
    storeCalendarEvent.dtFrom = e.dateStr;
    FxLog.infox('MxCalendarView.doEventClick', '...e.event:', e.event);
    storeCalendarEvent.boComm = e.event.extendedProps.hasComm === '1';

    if (r_calView.current === 'timeGridWeek' || r_calView.current === 'listWeek' || r_calView.current === 'timeGridDay') {
      // vista simple
      storeCalendarEvent.itCalendarCol = storeCalendarView.itCalendarCol;
      storeCalendarEvent.txTypeCalendarCol = storeCalendarView.txTypeCalendarCol;
    } else {
      // vista de recursos/columnas
      const resource = e.event.getResources()[0];
      storeCalendarEvent.itCalendarCol = resource.id;
      storeCalendarEvent.txTypeCalendarCol = resource.title;
    }

    Promise.all([setStoreCalendarEvent(storeCalendarEvent)]).then((result) => {
      navTo("calendar-form");
    });
  }

  const doEventDrop = (e) => {
    try {

      //const { start, end } = e.oldEvent._instance.range;
      //console.log(start, end);

      const { start: newStart, end: newEnd } = e.event._instance.range;
      let inCalendar = e.event.id;
      let dtFrom = new Date(newStart).toISOString();
      dtFrom = `${dtFrom.substring(0, 10)} ${dtFrom.substring(11, 16)}:00`;
      let dtTo = new Date(newEnd).toISOString();
      dtTo = `${dtTo.substring(0, 10)} ${dtTo.substring(11, 16)}:00`;

      //-----------------------------------------------------------------------
      let url = "cal/m";
      let record = {};
      record['inCalendar'] = inCalendar;
      if (r_calView.current === 'timeGridWeek' || r_calView.current === 'listWeek' || r_calView.current === 'timeGridDay') {
        // vista simple
        record['itCalendarCol'] = storeCalendarView.itCalendarCol;
      } else {
        // vista de recursos/columnas
        if (e.newResource) {
          record['itCalendarCol'] = e.newResource.id;
        }
      }

      record['dtFrom'] = dtFrom;
      record['dtTo'] = dtTo;
      // enviamos también los settings
      record['boSingleCalendar'] = storeCalendarView.boSingleCalendar;
      record['txWeekDays'] = storeCalendarView.txWeekDays;
      record['txStartHour'] = storeCalendarView.txStartHour;
      record['txWorkTime1From'] = storeCalendarView.txWorkTime1From;
      record['txWorkTime1To'] = storeCalendarView.txWorkTime1To;
      record['txWorkTime2From'] = storeCalendarView.txWorkTime2From;
      record['txWorkTime2To'] = storeCalendarView.txWorkTime2To;
      Promise.all([FxFetch.doJsonX(url, record)]).then((result) => {
        if (result[0]) {
        } else {
          e.revert();
          r_snack_error.current.setValAndOpen(trans('msg.time_overlap'));
        }
      });
      //-----------------------------------------------------------------------

    } catch (error) {
      FxLog.errorx("MxCalendarView.doEventDrop", error);
    }
  }

  const fetchEvents = async () => {
    let record = {};
    record['boSingleCalendar'] = storeCalendarView.boSingleCalendar;
    record['selectedDate'] = storeCalendarView.selectedDate;
    record['calView'] = r_calView.current;
    if (!r_calView.current.includes('resource')) {
      record['itCalendarCol'] = storeCalendarView.itCalendarCol;
    }
    setCalEvents(''); // 2024-01-20 - daq: para evitar que en la vista de recursos predespliegue con todas las columnas

    return Promise.all([FxFetch.doJsonX("cal", record)]).then((result) => {
      if (result[0]) {
        if (result[0].length > 0) {
          const eventsWithReminderClass = result[0].map(ev => {
            FxLog.infox('MxCalendarView.fetchEvents', '...inCalendar/hasComm:', `${ev.inCalendar} / ${ev.hasComm}`);
            if (ev.hasComm === '1' || ev.hasComm === true) {
              return {
                ...ev,
                classNames: [ ...(ev.classNames || []), 'ibs-event-has-reminder' ]
              };
            }
            return ev;
          });

          setCalEvents(eventsWithReminderClass);
        } else {
          FxLog.infox("MxCalendarView.fetchEvents", "NO hay eventos...");
          setCalEvents([]); // por limpieza
        }
      } else {
        FxLog.infox("MxCalendarView.fetchEvents", "NO hay resultados!!");
        setCalEvents([]);
      }
    });
  }

  const doButtonToday = () => {
    rf_calendar.current.getApi().today();
    doDatesSet();
  }

  const doButtonPrev = () => {
    rf_calendar.current.getApi().prev();
    doDatesSet();
  }

  const doButtonNext = () => {
    rf_calendar.current.getApi().next();
    doDatesSet();
  }

  const doButtonWeek = () => {
    setView('timeGridWeek');
    doDatesSet();
  }

  const doButtonListWeek = () => {
    setView('listWeek');
    doDatesSet();
  }

  const doButtonDay = () => {
    setView('timeGridDay');
    doDatesSet();
  }

  const doButtonRes = () => {
    setView('resourceTimeGridDay');
    doDatesSet();
  }

  const doButtonResWeek = () => {
    setView('resourceTimeGridWeek');
    doDatesSet();
  }

  const setView = (newView) => {
    rf_calendar.current.getApi().changeView(newView);

    const isResourceView = newView === 'resourceTimeGridDay' || newView === 'resourceTimeGridWeek';
    rf_popper1.current.setVisible(!isResourceView);
    rf_popper2.current.setVisible(isResourceView);

    switch (newView) {
      case 'timeGridWeek':
        setCalView({ title: trans('field.week'), bg: 'var(--cal_color_week)' });
        break;

      case 'resourceTimeGridWeek':
        let colsSelectedWeek = localStorage.getItem('MxCalendarView.colsSelected') || '';
        if (!colsSelectedWeek) {
          rf_popper2.current.setTooltipText(trans('msg.select_x', 'field.columns'));
        }
        setCalColsSelected(colsSelectedWeek);
        setCalView({ title: `${trans('field.week')}/${trans('field.column')}`, bg: 'var(--cal_color_res_week)' });
        break;

      case 'timeGridDay':
        setCalView({ title: trans('field.day'), bg: 'var(--cal_color_day)' });
        break;

      case 'resourceTimeGridDay':
        let colsSelected = localStorage.getItem('MxCalendarView.colsSelected') || '';
        FxLog.infox('MxCalendarView.setView', '...colsSelected:', colsSelected);
        if (!colsSelected) {
          rf_popper2.current.setTooltipText(trans('msg.select_x', 'field.columns'));
        }
        setCalColsSelected(colsSelected);
        setCalView({ title: `${trans('field.day')}/${trans('field.column')}`, bg: 'var(--cal_color_res_day)' });
        break;

      case 'listWeek':
        setCalView({ title: trans('field.list'), bg: 'var(--cal_color_list)' });
        break;

      default: break;
    }
  }

  const doDateSelected = (d) => {
    setDlgNewDate(false);
    let _date = d || '';
    if (_date) {
      rf_calendar.current.getApi().gotoDate(_date);
      doDatesSet();
    }
  }

  const doDatesSet = async () => {
    r_calView.current = rf_calendar.current.getApi().view.type;
    // obtiene fecha actual y le le añade 1 día para que sea desde el lunes, y no domingo.
    r_calDate.current = FxDat.addDays(rf_calendar.current.getApi().view.activeStart.toISOString().split('T')[0], 1);

    // 2022-05-05
    storeCalendarView.selectedView = r_calView.current; // guarda vista, para poder volver con initialDate, luego de editar un evento.
    storeCalendarView.selectedDate = r_calDate.current; // guarda fecha, para poder volver con initialDate, luego de editar un evento.
    setStoreCalendarView(storeCalendarView);

    localStorage.setItem('MxCalendarView.lastCalendarView', storeCalendarView.selectedView);
    localStorage.setItem('MxCalendarView.lastCalendarDate', storeCalendarView.selectedDate);

    return fetchEvents();
  }

  const getColsToDisplay = () => {
    if (r_calView.current === 'timeGridWeek' || r_calView.current === 'listWeek' || r_calView.current === 'timeGridDay') {
      // vista simple
      return calCols;
    } else {
      // vista de recursos/columnas
      // dejamos sólo las seleccionadas
      let colsFiltered = calCols.filter(col => calColsSelected.includes(col.id));
      return colsFiltered;
    };
  }

  const getHiddenDays = () => {
    let hidden = [];
    if (storeCalendarView.txWeekDays?.charAt(6) === '0') hidden.push(0); // domingo
    if (storeCalendarView.txWeekDays?.charAt(0) === '0') hidden.push(1); // lunes
    if (storeCalendarView.txWeekDays?.charAt(1) === '0') hidden.push(2); // martes
    if (storeCalendarView.txWeekDays?.charAt(2) === '0') hidden.push(3); // miércoles
    if (storeCalendarView.txWeekDays?.charAt(3) === '0') hidden.push(4); // jueves
    if (storeCalendarView.txWeekDays?.charAt(4) === '0') hidden.push(5); // viernes
    if (storeCalendarView.txWeekDays?.charAt(5) === '0') hidden.push(6); // sábado

    return hidden;
  }

  const doSearch = (row) => {
    let _date = row.original.dtFrom.split(' ')[0];
    let _time = row.original.dtFrom.split(' ')[1].substring(0, 8);
    rf_calendar.current.getApi().gotoDate(_date);
    Promise.all([doDatesSet()]).then((result) => {
      rf_calendar.current.getApi().scrollToTime(_time);
    });

    setDlgSearch(false);
  }

  // ─── FESTIVOS: helpers ────────────────────────────────────────────────────────
  const getHolidayForDate = (date) => {
    // toISOString() usa UTC y puede devolver el día anterior en zonas UTC+N
    // Usamos fecha local para evitar el desfase
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const dateStr = `${y}-${m}-${d}`;
    return holidays.find(h => h.start === dateStr) || null;
  };

  // Genera background events para colorear la columna.
  // IMPORTANTE: el end debe ser el día siguiente a T00:00:00, no T24:00:00,
  // porque JS interpreta T24:00:00 como medianoche del día siguiente
  // y el background se derrama al día de después.
  const getHolidayEvents = () => {
    const boIsListView = r_calView.current === 'listWeek';
    const boIsResourceDayView = r_calView.current === 'resourceTimeGridDay';

    return holidays.map(h => {
      const [year, month, day] = h.start.split('-').map(Number);
      const strNextDay = new Date(Date.UTC(year, month - 1, day + 1)).toISOString().split('T')[0];

      if (boIsListView) {
        return {
          id: `holiday-${h.id}`,
          title: `${trans('field.holiday')}: ${h.name}`,
          start: h.start,
          allDay: true,
          classNames: ['ibs-calendar-holiday', h.className],
          editable: false,
          extendedProps: { isHoliday: true },
        };
      }

      if (boIsResourceDayView) {
        return calCols.map(col => ({
          start: `${h.start}T${storeCalendarView.txStartHour || '07:00:00'}`,
          end: `${strNextDay}T00:00:00`,
          display: 'background',
          resourceId: String(col.id),
          classNames: ['ibs-holiday-bg', h.className],
          extendedProps: { isHoliday: true },
        }));
      }

      return {
        start: `${h.start}T00:00:00`,
        end: `${strNextDay}T00:00:00`,
        display: 'background',
        classNames: ['ibs-holiday-bg', h.className],
        extendedProps: { isHoliday: true },
      };
    }).flat();
  };

  // Asistente de Programacion - 2026-03-30
  const renderDayHeader = (args) => {
    const holiday = getHolidayForDate(args.date);
    const boIsRegional = holiday?.className === 'ibs-holiday-regional';
    const strTextColor  = !holiday ? undefined : boIsRegional ? '#b7770d' : '#c0392b';
    const strBadgeBg    = boIsRegional ? '#f1c40f' : '#c0392b';
    const strBadgeColor = boIsRegional ? '#000'    : '#fff';
    return (
      <div style={{ display: 'flex', width: '100%', alignItems: 'center', position: 'relative' }}>
        <span style={{ position: 'absolute', left: '5px', fontWeight: 'bold', fontSize: '14px', color: strTextColor }}>
          {args.date.getDate()}
        </span>
        <span style={{ flex: 1, textAlign: 'center', textTransform: 'capitalize', color: strTextColor }}>
          {args.date.toLocaleDateString(strLocale, { weekday: 'long' })}
          {holiday && (
            <span
              title={holiday.name}
              style={{
                display: 'inline-block', marginLeft: '6px',
                background: strBadgeBg, color: strBadgeColor,
                fontSize: '9px', fontWeight: 'bold',
                padding: '1px 4px', borderRadius: '3px',
                verticalAlign: 'middle', letterSpacing: '0.5px',
                textTransform: 'uppercase',
                cursor: 'help',
              }}
            >
              {trans('field.holiday')}
            </span>
          )}
        </span>
      </div>
    );
  };

  // Asistente de Programacion - 2026-03-30
  const handleMouseEnter = (info) => {
    if (info.event.extendedProps.isHoliday) return;

    const dtStart = info.event.start;
    const dtEnd = info.event.end;
    
    if (!dtStart || !dtEnd) return;

    // Usamos moment para ser consistentes con tu FxDat
    const mStart = moment(dtStart);
    const mEnd = moment(dtEnd);
    
    const intDurationMin = mEnd.diff(mStart, 'minutes');
    
    // Usamos el formato de hora de tu app
    const strTimeRange = `${mStart.format("HH:mm")} - ${mEnd.format("HH:mm")}`;
    const strTooltip = `${strTimeRange} (${intDurationMin} min.)`;
    
    info.el.setAttribute('title', strTooltip);
  };  

  
  return (
    <div id='div_MxCalendarView'>
      <CxToolbar xref={rf_toolbar}
        moduleName={window.innerWidth > MIN_WIDTH ? `${trans('field.calendar')}: ${calView.title}` : `${trans('field.calendar')}`}
        background={`${calView.bg}`}
        //help="calendar"
        gap="0px" /*quitamos gap para evitar desplazamiento de CxToolbarPopper*/
        addToolbarButtons={
          <div style={{ display: 'flex', whiteSpace: 'nowrap', margin: '0px 6px 0px 0px', gap: '4px' }}>
            <CxIconButtonNew
              onClick={doRefresh} className="ibs_iconbutton_toolbar"
              icon={<BiRefresh fontSize="30px" style={{ margin: '-3px -4px 0 0' }} />}
              tooltip={trans('field.refresh')}
            />
            <CxIconButtonNew
              onClick={() => setDlgSearch(true)} className="ibs_iconbutton_toolbar"
              icon={<BsSearch fontSize="20px" style={{ marginTop: '0px' }} />}
              tooltip={trans('field.search_x', 'field.event')}
            />
            <CxIconButtonNew
              onClick={() => setDlgNewDate(true)} className="ibs_iconbutton_toolbar"
              icon={<BsCalendar fontSize="20px" style={{ marginTop: '0px' }} />}
              tooltip={trans('msg.select_x', 'field.date')}
            />
            <CxIconButtonNew
              onClick={doExportPdf} className="ibs_iconbutton_toolbar"
              icon={<BsFileEarmarkPdf fontSize="20px" style={{ marginTop: '1px' }} />}
              tooltip={trans('field.export_to_x', 'PDF')}
            />            
            <CxIconButtonNew
              onClick={() => setDlgGoogleImport(true)} className="ibs_iconbutton_toolbar"
              icon={<SiGooglecalendar fontSize="20px" style={{ margin: '1px 0 0 0px' }} />}
              tooltip={trans('field.import_x', 'Google Calendar')}
            />            
          </div>
        }
      >
        <CxToolbarPopper xref={rf_popper1}
          width='155px'
          list={calCols}
          onSelection={doDisplayCol}
          visible={storeCalendarView.selectedView !== 'resourceTimeGridDay'}
        />
        <CxToolbarPopper xref={rf_popper2}
          width='155px'
          onCustomClick={doResColsChoose}
          value={trans('field.columns')}
          visible={storeCalendarView.selectedView === 'resourceTimeGridDay'}
          tooltipType="controlled"
        />
      </CxToolbar>

      <div className={classes.calendar}>
        <FullCalendar
          themeSystem="standard"
          ref={rf_calendar}
          locales={allLocales}
          locale={strLocale} //the initial locale "es-ES" {session.txLocale}
          plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin, resourceTimeGridPlugin]}
          schedulerLicenseKey={'CC-Attribution-NonCommercial-NoDerivatives'}
          resources={getColsToDisplay()}
          datesAboveResources={true}
          resourceOrder={'sequence'}
          customButtons={{
            customButtonWeek: { text: `${trans('field.week')}`, click: function () { doButtonWeek() }, },
            customButtonResWeek: { text: `${trans('field.week')}/col`, click: function () { doButtonResWeek() }, },
            customButtonDay: { text: `${trans('field.day')}`, click: function () { doButtonDay() }, },
            customButtonRes: { text: `${trans('field.day')}/col`, click: function () { doButtonRes() }, },
            customButtonListWeek: { text: trans('field.list'), click: function () { doButtonListWeek() }, },
            customButtonToday: { text: trans('field.today'), click: function () { doButtonToday() }, },
            customButtonPrev: { text: '◀', click: function () { doButtonPrev() }, },
            customButtonNext: { text: '▶', click: function () { doButtonNext() }, },
          }}
          slotMinTime={storeCalendarView.txStartHour || '07:00:00'} // hora inicial
          slotMaxTime='24:00:00' // hora final
          hiddenDays={getHiddenDays()}
          businessHours={[
            { daysOfWeek: [0, 1, 2, 3, 4, 5, 6], startTime: storeCalendarView.txWorkTime1From || '', endTime: storeCalendarView.txWorkTime1To || '', },
            { daysOfWeek: [0, 1, 2, 3, 4, 5, 6], startTime: storeCalendarView.txWorkTime2From || '', endTime: storeCalendarView.txWorkTime2To || '', },
          ]}
          dateClick={isFullAccess() && doDateClick}
          eventClick={doEventClick}
          events={[...calEvents, ...getHolidayEvents()]}
          resourceLabelClassNames={(args) => {
            if (r_calView.current !== 'resourceTimeGridDay') return [];
            const date = args.date || (rf_calendar.current && rf_calendar.current.getApi().getDate());
            const holiday = date && getHolidayForDate(date);
            return holiday ? ['ibs-holiday-header', holiday.className] : [];
          }}
          dayHeaderClassNames={(args) => {
            const holiday = getHolidayForDate(args.date);
            if (!holiday) return [];
            return ['ibs-holiday-header', holiday.className]; // ibs-holiday-national o ibs-holiday-regional
          }}
          displayEventTime={r_calView.current === 'listWeek'}
          noEventsContent={""} //mensaje en la vista de listado cuando no hay eventos.
          weekends={true}
          allDaySlot={false} //no permite eventos multidía; en su lugar permitiremos repetir eventos.
          firstDay="1" //la semana comienza el lunes y no el domingo
          headerToolbar={getHeaderToolbar()}
          initialView={window.innerWidth > MIN_WIDTH ? storeCalendarView.selectedView || 'timeGridWeek' : 'timeGridDay'}
          initialDate={storeCalendarView.selectedDate || null} // 2022-05-05 para que al volver de un evento muestre la fecha donde estaba.
          contentHeight={window.innerHeight - r_headerSize.current}
          eventTimeFormat={{ // like '14:30:00'
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          }}
          titleFormat={{ year: '2-digit', month: 'short', day: 'numeric' }}
          slotLabelFormat={{
            hour: '2-digit',
            minute: '2-digit',
            omitZeroMinute: false,
            meridiem: false,
            hour12: false
          }}
          slotDuration={{ minutes: storeCalendarView.nuIntervalMins||15 }}
          slotLabelInterval={{ minutes: storeCalendarView.nuIntervalMins||15 }}
          snapDuration={{ minutes: 15 }}
          editable={isFullAccess()}
          longPressDelay={1000}
          eventDrop={doEventDrop}
          eventResize={doEventDrop}
          dayHeaderFormat={{ weekday: 'long', day: 'numeric' }} // Fuerza: "lunes 30"
          dayHeaderContent={renderDayHeader}
          eventMouseEnter={handleMouseEnter}
          nowIndicator={true}
        />
      </div>

      <CxDlgCheckList xref={r_dlg_res_cols} onOk={doResColsChanged} title={trans('field.columns')} />

      <CxDlgCalendar
        xref={r_dlg_calendar}
        open={dlgNewDate}
        onClose={(d) => doDateSelected(d)}
        title={trans('msg.select_x', 'field.date')}
      />

      <CxDlgTable
        xref={r_dlg_search}
        hasSearchBox={true}
        open={dlgSearch}
        onSelect={doSearch}
        onClose={() => setDlgSearch(false)}
        url={'cal/search'}
        tooltip={(isApp('vett') || isApp('spaw')) ? `${trans('field.client')} / ${trans('field.patient')}` : `${trans('field.client')}`}
        columns={(isApp('vett') || isApp('spaw')) ?
          [
            { id: "0", Header: "ID", accessor: "inCalendar", show: false },
            { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDateTime(row["dtFrom"]), width: '25%' },
            { id: "2", Header: trans('field.client'), accessor: row => r_dlg_search.current.getTable().highlightText(row["txClient"]), width: '50%' },
            { id: "3", Header: trans('field.patient'), accessor: row => r_dlg_search.current.getTable().highlightText(row["txAnimal"]), width: '25%' },
          ]
          :
          [
            { id: "0", Header: "ID", accessor: "inCalendar", show: false },
            { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDateTime(row["dtFrom"]), width: '25%' },
            { id: "2", Header: trans('field.client'), accessor: row => r_dlg_search.current.getTable().highlightText(row["txClient"]), width: '50%' },
          ]
        }
        title={trans('field.search')}
        height='450px'
      />

      <CxDialog
        title={trans('field.import_x', 'Google Calendar')}
        open={dlgGoogleImport}
        onCancel={() => setDlgGoogleImport(false)}
        onOk={() => doSynchGoogleCalendar()}
        height='300px'>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }} >
          <CxDate xref={rf_google_import_dtFrom} label={trans('field.from')} width='var(--ibs_control_width_md)' today required />
          <CxDate xref={rf_google_import_dtTo} label={trans('field.to')} width='var(--ibs_control_width_md)' todayAdd={7} required />
        </div>
      </CxDialog>


      <CxDlgAlert xref={r_dlg_alert} />

      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );

}

export default MxCalendarView;